/**
 * Home Page
 * Main landing page with all sections based on portal config
 */

import React from 'react';
import { usePortal } from '../context/PortalContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/sections/HeroSection';
import ProductsSection from '../components/sections/ProductsSection';
import ServicesSection from '../components/sections/ServicesSection';
import AboutSection from '../components/sections/AboutSection';
import ContactSection from '../components/sections/ContactSection';
import NewsletterSection from '../components/sections/NewsletterSection';

const HomePage = () => {
  const { loading, error, isSectionVisible, branding, portal } = usePortal();

  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="loading">
        <p>Failed to load site configuration</p>
      </div>
    );
  }

  // Get hero config from portal
  const heroConfig = portal?.landingPage?.hero || {};

  return (
    <>
      <Header />
      
      {/* Hero Section - Always visible */}
      {isSectionVisible('hero') && (
        <HeroSection 
          title={heroConfig.title || branding.businessName}
          subtitle={heroConfig.subtitle || 'Welcome to our store'}
          ctaText={heroConfig.ctaText || 'Shop Now'}
          ctaLink={heroConfig.ctaLink || '/products'}
          backgroundImage={heroConfig.backgroundImage}
        />
      )}

      {/* Products Section */}
      {isSectionVisible('products') && (
        <ProductsSection 
          title="Our Products"
          limit={6}
        />
      )}

      {/* Services Section */}
      {isSectionVisible('services') && (
        <ServicesSection 
          title="Our Services"
          limit={6}
        />
      )}

      {/* About Section */}
      {isSectionVisible('about') && (
        <AboutSection />
      )}

      {/* Newsletter Section */}
      {isSectionVisible('newsletter') && (
        <NewsletterSection />
      )}

      {/* Contact Section */}
      {isSectionVisible('contact') && (
        <ContactSection />
      )}

      <Footer />
    </>
  );
};

export default HomePage;
